import React from "react";
import logo from "resources/img/logo-yusados.svg";
import "./styles.scss";

export default class Logo extends React.Component {
  render() {
    return (
      <div className="ylogo">
        <img className="yacopini" src={logo} alt="Yacopini Usados" />
      </div>
    );
  }
}
